"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/PatientActions.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);












var _user = require('shared/selectors/user');
var _team = require('shared/selectors/team');
var _teams = require('shared/selectors/myRelations/teams');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Avatar = require('web/components/Avatar');
var _CampaignStatus = require('web/screens/Broadcast/CampaignStatus'); var _CampaignStatus2 = _interopRequireDefault(_CampaignStatus);
var _DirectoryCreateNewModal = require('web/screens/Directory/DirectoryCreateNewModal'); var _DirectoryCreateNewModal2 = _interopRequireDefault(_DirectoryCreateNewModal);
var _types = require('web/screens/Directory/types');
var _format = require('./format');

// isArchived: the side panel's patient is archived, whichever view the table
// shows (review F-3), so tagging them reads the Archived view.






















const plural = (n, one, many) => `${_format.formatCount.call(void 0, n)} ${n === 1 ? one : many}`

// Patients an action left out because they're in a running archive or
// restore (review F-14).
const leftOutText = (n) => n ? `; ${plural(n, 'patient', 'patients')} being archived or restored ${n === 1 ? 'was' : 'were'} left out` : ''

const errorText = (e, fallback) => {
  const message = _optionalChain([(e ), 'optionalAccess', _ => _.Error])
  return typeof message === 'string' && message ? message : fallback
}

/* ---- Add tag (patients-v3-tag, patients-v3-tag-create) ---- */

const TagDialog







 = ({ count, isOne, tags, isBusy, onClose, onAdd, onRemove }) => {
  const [search, setSearch] = _react.useState.call(void 0, '')
  const [chosen, setChosen] = _react.useState(null)
  const name = search.trim()
  const matches = tags.filter(t => t.Name.toLowerCase().includes(name.toLowerCase()))
  const exact = tags.find(t => t.Name.trim().toLowerCase() === name.toLowerCase())
  const chosenTag = _nullishCoalesce(tags.find(t => t.TagKey === chosen), () => ( null))
  const isNew = chosen === 'new' || (!!name && !exact && matches.length === 0)
  const who = isOne ? 'this patient' : `the ${plural(count, 'selected patient', 'selected patients')}`
  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, title: "Add tag" , className: "broadcast-add-dialog dir-dialog--tag" , bodyClassName: "broadcast-add-dialog--body dir-dialog--body dir-dialog--short"  , onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      , _react2.default.createElement('p', { className: "broadcast-add-existing--lead", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Tag "
         , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}},  who ), ". Tags are shared by everyone in your organization; anyone can create one."
      )
      , _react2.default.createElement('div', { className: "broadcast-add-dialog--pane", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
        , _react2.default.createElement('input', {
          className: "blm-text-input broadcast-picker--search-input broadcast-add-existing--search"  ,
          placeholder: "Search or create a tag"    ,
          'aria-label': "Search or create a tag"    ,
          type: "search",
          maxLength: 64,
          value: search,
          onChange: e => {
            setSearch(e.target.value)
            setChosen(null)
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
        )
        , _react2.default.createElement('div', { className: "broadcast-add-dialog--results broadcast-add-existing--results" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
          ,  matches.length > 0 && (
            _react2.default.createElement('table', { className: "campaign--table broadcast-add-existing--table" , 'aria-label': "Tags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
              , _react2.default.createElement('colgroup', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, _react2.default.createElement('col', { style: { width: 46 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}} ), _react2.default.createElement('col', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 104}} ), _react2.default.createElement('col', { style: { width: 140 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}} ))
              , _react2.default.createElement('tbody', { className: "campaign--table--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
                ,  matches.map(tag => {
                  const isChosen = chosen === tag.TagKey
                  return (
                    _react2.default.createElement('tr', {
                      key: tag.TagKey,
                      className: _classBuilder2.default.call(void 0, 'campaign--table--row', isChosen && 'broadcast-add-existing--row-selected'),
                      onClick: () => setChosen(isChosen ? null : tag.TagKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}

                      , _react2.default.createElement('td', { className: "campaign--table--row-checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
                        , _react2.default.createElement('label', { className: "campaign--table--checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
                          , _react2.default.createElement('input', {
                            className: "broadcast-visually-hidden",
                            'aria-label': `Add ${tag.Name}`,
                            type: "checkbox",
                            checked: isChosen,
                            onChange: () => setChosen(isChosen ? null : tag.TagKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}
                          )
                          , _react2.default.createElement('div', { className: "campaign--table--checkbox-check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}} )
                        )
                      )
                      , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, _react2.default.createElement('span', { className: "blm-name--badge dir-tag" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}},  tag.Name ))
                      , _react2.default.createElement('td', { className: "dir-num dir-cell--quiet" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}},  plural(_nullishCoalesce(tag.Patients, () => ( 0)), 'patient', 'patients') )
                    )
                  )
                })
              )
            )
          )
          ,  name && !exact && matches.length === 0 && (
            _react2.default.createElement('p', { className: "broadcast-add-dialog--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}, "No tag is called “"    ,  name , "” yet." )
          )
          ,  name && !exact && (
            _react2.default.createElement('button', {
              type: "button",
              className: _classBuilder2.default.call(void 0, 'broadcast-add-dialog--add-new', isNew && 'dir-add-new--active'),
              onClick: () => setChosen('new'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}

              , _react2.default.createElement('span', { className: "broadcast-add-dialog--add-new-icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}, "+"), "Create tag “"
                ,  name , "”",  matches.length === 0 ? ' for everyone in your organization' : '' 
            )
          )
        )
        , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot dir-dialog--foot" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
          , _react2.default.createElement('span', { className: "broadcast-add-dialog--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
            ,  isNew ? 'New tag' : _nullishCoalesce(_optionalChain([chosenTag, 'optionalAccess', _2 => _2.Name]), () => ( 'Choose a tag')) , " · "  ,  plural(count, 'patient', 'patients') 
          )
          , _react2.default.createElement('div', { className: "dir-dialog--foot-buttons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}
            , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}, "Cancel")
            ,  chosenTag && (
              _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , disabled: isBusy, onClick: () => onRemove(chosenTag), __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}, "Remove tag"

              )
            )
            , _react2.default.createElement('button', {
              type: "button",
              className: "blm-btn blm-btn--primary" ,
              disabled: isBusy || (!isNew && !chosenTag),
              onClick: () => onAdd(isNew ? { NewTagName: name } : { TagKey: chosenTag.TagKey }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}

              ,  isNew ? 'Create and add tag' : 'Add tag' 
            )
          )
        )
      )
    )
  )
}

/* ---- Add to broadcast (patients-v3-broadcast) ---- */

const BROADCAST_LIST_LIMIT = 30

const BroadcastDialog








 = ({ orgKey, count, isOne, selection, isBusy, onClose, onAdd, onCreate }) => {
  const [mode, setMode] = _react.useState('existing')
  const [search, setSearch] = _react.useState.call(void 0, '')
  const [campaigns, setCampaigns] = _react.useState(null)
  const [chosen, setChosen] = _react.useState(null)
  const [counts, setCounts] = _react.useState(null)
  const [countError, setCountError] = _react.useState(null)
  const [name, setName] = _react.useState.call(void 0, '')
  const myTeamKeys = _hooks.useAppSelector.call(void 0, _teams.selectMyTeamKeys)
  const teams = _hooks.useAppSelector.call(void 0, _team.selectTeams)
  const orgTeams = _react.useMemo.call(void 0, 
    () => myTeamKeys.map(k => teams[k]).filter((t) => !!t && t.OrgKey === orgKey),
    [myTeamKeys, teams, orgKey],
  )
  const [teamKey, setTeamKey] = _react.useState('')
  _react.useEffect.call(void 0, () => { if (!teamKey && orgTeams[0]) setTeamKey(orgTeams[0].TeamKey) }, [orgTeams, teamKey])

  // Every unarchived broadcast on the user's teams in this org, page by page
  // per team, so the search reaches them all (review F-6).
  const orgTeamKeys = orgTeams.map(t => t.TeamKey).join(',')
  _react.useEffect.call(void 0, () => {
    let isCurrent = true
    const teamBroadcasts = async (key) => {
      const found = []
      for (let offset = 0; ; offset += BROADCAST_LIST_LIMIT) {
        const r = await _actions2.default.findCampaigns({ TeamKey: key, Archived: false, Offset: offset, Limit: BROADCAST_LIST_LIMIT })
        found.push(...r.Campaigns)
        if (r.Campaigns.length < BROADCAST_LIST_LIMIT) return found
      }
    }
    // SAFETY: orgTeamKeys holds this org's TeamKeys, joined above.
    const keys = (orgTeamKeys ? orgTeamKeys.split(',') : []) 
    Promise.all(keys.map(teamBroadcasts))
      .then(lists => {
        if (!isCurrent) return
        const newestFirst = (a, b) => b.CreatedAt.localeCompare(a.CreatedAt)
        setCampaigns(lists.flat().filter(c => c.OrgKey === orgKey && !c.Archived).sort(newestFirst))
      })
      .catch(() => { if (isCurrent) setCampaigns([]) })
    return () => { isCurrent = false }
  }, [orgKey, orgTeamKeys])

  // The counts for the chosen broadcast: new, already on it, can't receive.
  // The selection is memoised by the caller, so it changes only with the dialog's target.
  _react.useEffect.call(void 0, () => {
    setCounts(null)
    setCountError(null)
    if (!chosen) return
    let isCurrent = true
    _actions2.default.previewPatientsForBroadcast({ OrgKey: orgKey, CampaignKey: chosen.CampaignKey, Selection: selection })
      .then(c => {
        if (!isCurrent) return
        // A server that doesn't echo the patients left out would add them
        // (P-1): nothing is added through it.
        if (_optionalChain([selection, 'access', _3 => _3.LeftOut, 'optionalAccess', _4 => _4.length]) && typeof c.LeftOut !== 'number') {
          setCountError('This server can\'t leave patients out yet. Nothing was added.')
          return
        }
        setCounts(c)
      })
      .catch(e => { if (isCurrent) setCountError(errorText(e, 'Couldn\'t count the patients for this campaign.')) })
    return () => { isCurrent = false }
  }, [chosen, orgKey, selection])

  const shown = (_nullishCoalesce(campaigns, () => ( []))).filter(c => c.Name.toLowerCase().includes(search.trim().toLowerCase()))
  const teamName = (key) => _nullishCoalesce(_optionalChain([teams, 'access', _5 => _5[key], 'optionalAccess', _6 => _6.Name]), () => ( ''))
  const who = isOne ? 'this patient' : `the ${plural(count, 'selected patient', 'selected patients')}`
  const canAdd = mode === 'existing' ? !!chosen && !!counts && counts.New > 0 : !!name.trim() && !!teamKey
  const addLabel = mode === 'existing'
    ? (counts ? `Add ${plural(counts.New, 'patient', 'patients')}` : 'Add patients')
    : `Create and add ${plural(count, 'patient', 'patients')}`

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, title: "Add to campaign"  , className: "broadcast-add-dialog", bodyClassName: "broadcast-add-dialog--body dir-dialog--body dir-dialog--short"  , onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}
      , _react2.default.createElement('p', { className: "broadcast-add-existing--lead", __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}, "Add "
         , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 262}},  who ), " to a campaign. Nothing is sent until someone sends it."
      )
      , _react2.default.createElement('div', { className: "dir-dialog--choice", role: "radiogroup", 'aria-label': "Campaign", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
        ,  (['existing', 'new'] ).map(value => (
          _react2.default.createElement('div', {
            key: value,
            role: "radio",
            'aria-checked': mode === value,
            tabIndex: 0,
            className: _classBuilder2.default.call(void 0, 'blm-form--radio-input--option', mode === value && 'selected'),
            onClick: () => setMode(value),
            onKeyDown: e => { if (e.key === 'Enter' || e.key === ' ') setMode(value) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}

            , _react2.default.createElement('span', { className: "blm-form--radio-input--option--circle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}} )
            , _react2.default.createElement('span', { className: "blm-form--radio-input--option--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}},  value === 'existing' ? 'Existing campaign' : 'New campaign' )
          )
        ))
      )
      ,  mode === 'existing'
        ? (
            _react2.default.createElement('div', { className: "broadcast-add-dialog--pane", __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}
              , _react2.default.createElement('input', {
                className: "blm-text-input broadcast-picker--search-input broadcast-add-existing--search"  ,
                placeholder: "Search campaigns" ,
                'aria-label': "Search campaigns" ,
                type: "search",
                value: search,
                onChange: e => setSearch(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 283}}
              )
              , _react2.default.createElement('div', { className: "broadcast-add-dialog--results broadcast-add-existing--results" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 291}}
                ,  campaigns === null && _react2.default.createElement('p', { className: "broadcast-add-dialog--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 292}}, "Loading campaigns…" ) 
                ,  campaigns !== null && shown.length === 0 && _react2.default.createElement('p', { className: "broadcast-add-dialog--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}}, "No campaigns on your teams"    ,  search.trim() ? ' match' : '' , ".") 
                ,  shown.length > 0 && (
                  _react2.default.createElement('table', { className: "campaign--table broadcast-add-existing--table" , 'aria-label': "Campaigns", __self: this, __source: {fileName: _jsxFileName, lineNumber: 295}}
                    , _react2.default.createElement('colgroup', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 296}}, _react2.default.createElement('col', { style: { width: 46 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}} ), _react2.default.createElement('col', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 296}} ), _react2.default.createElement('col', { style: { width: 150 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}} ), _react2.default.createElement('col', { style: { width: 250 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}} ), _react2.default.createElement('col', { style: { width: 96 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}} ))
                    , _react2.default.createElement('thead', { className: "campaign--table--head campaign--table--head--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 297}}
                      , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 298}}
                        , _react2.default.createElement('th', { className: "campaign--table--row-checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 299}} )
                        , _react2.default.createElement('th', { className: "campaign--table--col-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}}, "Campaign")
                        , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 301}}, "Team")
                        , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 302}}, "Status")
                        , _react2.default.createElement('th', { className: "dir-num", __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}, "Recipients")
                      )
                    )
                    , _react2.default.createElement('tbody', { className: "campaign--table--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 306}}
                      ,  shown.map(c => {
                        const isChosen = _optionalChain([chosen, 'optionalAccess', _7 => _7.CampaignKey]) === c.CampaignKey
                        const recipients = Object.values(c.Stats || {}).reduce((a, b) => a + (b || 0), 0)
                        return (
                          _react2.default.createElement('tr', { key: c.CampaignKey, className: _classBuilder2.default.call(void 0, 'campaign--table--row', isChosen && 'broadcast-add-existing--row-selected'), onClick: () => setChosen(c), __self: this, __source: {fileName: _jsxFileName, lineNumber: 311}}
                            , _react2.default.createElement('td', { className: "campaign--table--row-checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}}
                              , _react2.default.createElement('div', { role: "radio", 'aria-checked': isChosen, 'aria-label': c.Name, tabIndex: 0, className: _classBuilder2.default.call(void 0, 'blm-form--radio-input--option', isChosen && 'selected'),
                                onKeyDown: e => { if (e.key === 'Enter' || e.key === ' ') setChosen(c) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}}

                                , _react2.default.createElement('span', { className: "blm-form--radio-input--option--circle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 316}} )
                                , _react2.default.createElement('span', { className: "blm-form--radio-input--option--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 317}} )
                              )
                            )
                            , _react2.default.createElement('td', { className: "campaign--table--col-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 320}}
                              , _react2.default.createElement('div', { className: "campaign--table--col-name--inner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 321}}
                                , _react2.default.createElement(_Avatar.CampaignAvatar, { campaignKey: c.CampaignKey, size: 25, __self: this, __source: {fileName: _jsxFileName, lineNumber: 322}} )
                                , _react2.default.createElement('span', { className: "campaign--table--col-name--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 323}},  c.Name || 'Untitled campaign' )
                              )
                            )
                            , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 326}}, _react2.default.createElement('span', { className: "list-item--team", __self: this, __source: {fileName: _jsxFileName, lineNumber: 326}},  teamName(c.TeamKey) ))
                            , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 327}}, _react2.default.createElement(_CampaignStatus2.default, { campaignKey: c.CampaignKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 327}} ))
                            , _react2.default.createElement('td', { className: "dir-num", __self: this, __source: {fileName: _jsxFileName, lineNumber: 328}},  _format.formatCount.call(void 0, recipients) )
                          )
                        )
                      })
                    )
                  )
                )
              )
              ,  _optionalChain([counts, 'optionalAccess', _8 => _8.Sent]) && chosen && (
                _react2.default.createElement('div', { role: "status", className: "recipients-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 337}}
                  , _react2.default.createElement('span', { className: "recipients-notice--icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 338}}, "⚠")
                  , _react2.default.createElement('span', { className: "recipients-notice--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 339}}
                    , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 340}},  chosen.Name , " has already been sent."    ), " Adding patients does not text them. Only the patients you add are texted, when someone sends to them; the "                    ,  _format.formatCount.call(void 0, counts.AlreadyOn) , " already on it are skipped."
                  )
                )
              )
              ,  countError && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 344}},  countError ) 
            )
          )
        : (
            _react2.default.createElement('div', { className: "broadcast-add-dialog--pane dir-dialog--new" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 348}}
              , _react2.default.createElement('label', { className: "dir-confirm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 349}}
                , _react2.default.createElement('span', { className: "dir-confirm--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 350}}, "Name")
                , _react2.default.createElement('input', { className: "blm-text-input dir-confirm--input" , maxLength: 100, value: name, onChange: e => setName(e.target.value), 'aria-label': "Campaign name" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 351}} )
              )
              , _react2.default.createElement('label', { className: "dir-confirm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 353}}
                , _react2.default.createElement('span', { className: "dir-confirm--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 354}}, "Team")
                , _react2.default.createElement('select', { className: "blm-text-input dir-confirm--input" , 'aria-label': "Team", value: teamKey, onChange: e => setTeamKey(e.target.value ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 355}}
                  ,  orgTeams.map(t => _react2.default.createElement('option', { key: t.TeamKey, value: t.TeamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 356}},  t.Name )) 
                )
              )
            )
          )
      , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot dir-dialog--foot" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 361}}
        , _react2.default.createElement('span', { className: "broadcast-add-dialog--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 362}}
          ,  mode === 'existing' && counts
            ? `${_format.formatCount.call(void 0, counts.New)} new · ${_format.formatCount.call(void 0, counts.AlreadyOn)} already on it · ${_format.formatCount.call(void 0, counts.CantReceive)} can't receive texts`
            : plural(count, 'patient', 'patients') 
        )
        , _react2.default.createElement('div', { className: "dir-dialog--foot-buttons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 367}}
          , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 368}}, "Cancel")
          , _react2.default.createElement('button', {
            type: "button",
            className: "blm-btn blm-btn--primary" ,
            disabled: !canAdd || isBusy,
            onClick: () => mode === 'existing' ? onAdd(chosen.CampaignKey, chosen.Name || 'the campaign') : onCreate(name.trim(), teamKey ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 369}}

            ,  addLabel 
          )
        )
      )
    )
  )
}

/* ---- Archive (patients-v3-archive, with the D-27 body copy) ---- */

const ArchiveDialog = ({ count, isBusy, onClose, onConfirm }) => {
  const [typed, setTyped] = _react.useState.call(void 0, '')
  const countText = _format.formatCount.call(void 0, count)
  const isTyped = typed.replace(/[,\s]/g, '') === String(count)
  const noun = count === 1 ? 'patient' : 'patients'
  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, title: count === 1 ? 'Archive patient' : 'Archive patients', size: "xs", className: "dir-dialog--archive", onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 391}}
      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 392}}, "Archive " ,  countText , " " ,  noun , "?")
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 393}}, "They leave the patient table and are removed from every chat they're in. Their chats stay in your inboxes. You can still find them under Archived, and an admin can restore them, which adds them back to those chats."

      )
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 396}}, "If an archived patient texts in, they come back on their own and rejoin their chats."               )
      , _react2.default.createElement('label', { className: "dir-confirm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 397}}
        , _react2.default.createElement('span', { className: "dir-confirm--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 398}}, "Type " , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 398}},  countText ), " to confirm"  )
        , _react2.default.createElement('input', {
          className: "blm-text-input dir-confirm--input" ,
          type: "text",
          inputMode: "numeric",
          'aria-label': `Type ${countText} to confirm`,
          value: typed,
          onChange: e => setTyped(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 399}}
        )
      )
      , _react2.default.createElement('div', { className: "blm-modal--buttons-wrapper dir-modal--buttons" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 408}}
        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 409}}, "Cancel")
        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--danger" , disabled: !isTyped || isBusy, onClick: onConfirm, __self: this, __source: {fileName: _jsxFileName, lineNumber: 410}}, "Archive "
           ,  countText , " " ,  noun 
        )
      )
    )
  )
}

/* The selection's dialogs and what they run. Tag, untag and add to a
 * broadcast wait for the server, the bar showing they're working; archive
 * and restore run in the background, and a notice says when they're done
 * (D-38). Every action reports how many patients changed and how many were
 * skipped. */
const PatientActions = ({
  orgKey, action, onAction, onDone, selection, selectedCount, tags, isArchivedView, onArchiveStarted,
}) => {
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const me = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const close = _react.useCallback.call(void 0, () => onAction(null), [onAction])

  const patientKeys = action && 'patientKeys' in action ? action.patientKeys : undefined
  const isOne = !!patientKeys
  const target = _react.useMemo.call(void 0, () => patientKeys ? { PatientKeys: patientKeys } : selection, [patientKeys, selection])
  const count = patientKeys ? patientKeys.length : selectedCount
  const isArchived = action && 'isArchived' in action && action.isArchived !== undefined ? action.isArchived : isArchivedView
  const isBusy = !!_optionalChain([action, 'optionalAccess', _9 => _9.isBusy])
  const busy = _react.useCallback.call(void 0, () => action && onAction({ ...action, isBusy: true }), [action, onAction])

  const startArchive = _react.useCallback.call(void 0, (restore) => {
    busy()
    const run = restore ? _actions2.default.restorePatients : _actions2.default.archivePatients
    run({ OrgKey: orgKey, Selection: target })
      .then(r => {
        // The progress bar above the table says it started (D-61); a notice
        // only says which patients were left out, being in a running archive
        // or restore already.
        onArchiveStarted(r.TaskKey, { restore, count: r.Patients, closesPanel: isOne })
        if (r.InProgress) {
          showSuccessBar(`${restore ? 'Restoring' : 'Archiving'} ${plural(r.Patients, 'patient', 'patients')}. ${plural(r.InProgress, 'patient is', 'patients are')} already being archived or restored and ${r.InProgress === 1 ? 'was' : 'were'} left out.`)
        }
        close()
      })
      .catch(e => {
        showWarningBar(errorText(e, `Couldn't ${restore ? 'restore' : 'archive'} these patients. Nothing was changed.`))
        close()
      })
  }, [busy, orgKey, target, isOne, onArchiveStarted, showSuccessBar, showWarningBar, close])

  // Restore has no dialog (patients-v3-restore): it starts from the bar.
  _react.useEffect.call(void 0, () => {
    if (_optionalChain([action, 'optionalAccess', _10 => _10.kind]) === 'restore' && !action.isBusy) startArchive(true)
  }, [action, startArchive])

  // Removing one tag from one patient in the side panel needs no dialog.
  const untag = _react.useCallback.call(void 0, (tag, on) => {
    busy()
    _actions2.default.untagPatients({ OrgKey: orgKey, TagKey: tag.TagKey, Archived: isArchived, Selection: on })
      .then(r => {
        showSuccessBar(`Removed the tag ${tag.Name} from ${plural(r.Changed, 'patient', 'patients')}${r.Skipped ? `; ${_format.formatCount.call(void 0, r.Skipped)} didn't have it` : ''}${leftOutText(r.InProgress)}.`)
        close()
        onDone()
      })
      .catch(e => {
        showWarningBar(errorText(e, `Couldn't remove ${tag.Name}.`))
        close()
      })
  }, [busy, orgKey, isArchived, showSuccessBar, showWarningBar, close, onDone])
  _react.useEffect.call(void 0, () => {
    if (_optionalChain([action, 'optionalAccess', _11 => _11.kind]) === 'untag' && !action.isBusy) untag(action.tag, { PatientKeys: action.patientKeys })
  }, [action, untag])

  const addTag = _react.useCallback.call(void 0, (tag) => {
    busy()
    _actions2.default.tagPatients({ OrgKey: orgKey, ...tag, Archived: isArchived, Selection: target })
      .then(r => {
        showSuccessBar(`Added the tag ${r.Tag.Name} to ${plural(r.Changed, 'patient', 'patients')}${r.Skipped ? `; ${_format.formatCount.call(void 0, r.Skipped)} already had it` : ''}${leftOutText(r.InProgress)}.`)
        close()
        onDone()
      })
      .catch(e => {
        showWarningBar(errorText(e, 'Couldn\'t add the tag. Nothing was changed.'))
        close()
      })
  }, [busy, orgKey, isArchived, target, showSuccessBar, showWarningBar, close, onDone])

  const addToBroadcast = _react.useCallback.call(void 0, (campaignKey, name) => {
    busy()
    _actions2.default.addPatientsToBroadcast({ OrgKey: orgKey, CampaignKey: campaignKey, Selection: target })
      .then(r => {
        const already = r.AlreadyOn ? `; ${_format.formatCount.call(void 0, r.AlreadyOn)} already on it` : ''
        const cant = `${r.CantReceive ? `; ${_format.formatCount.call(void 0, r.CantReceive)} can't receive texts and won't be texted` : ''}${leftOutText(r.InProgress)}`
        showSuccessBar(`Added ${plural(r.New, 'patient', 'patients')} to ${name}${already}${cant}. Nothing was sent.`)
        close()
        onDone()
      })
      .catch(e => {
        showWarningBar(errorText(e, 'Couldn\'t add the patients to the campaign. Nothing was changed.'))
        close()
      })
  }, [busy, orgKey, target, showSuccessBar, showWarningBar, close, onDone])

  const createBroadcast = _react.useCallback.call(void 0, (name, teamKey) => {
    if (!me) return
    busy()
    _actions2.default.createCampaign({ Name: name, TeamKey: teamKey, SenderKey: me, MessageType: 'insecure_sms', MessageTemplate: '', MessageDelay: 500 })
      .then(campaign => addToBroadcast(campaign.CampaignKey, name))
      .catch(e => {
        showWarningBar(errorText(e, 'Couldn\'t create the campaign.'))
        close()
      })
  }, [me, busy, addToBroadcast, showWarningBar, close])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  _optionalChain([action, 'optionalAccess', _12 => _12.kind]) === 'create' && (
        _react2.default.createElement(_DirectoryCreateNewModal2.default, { isOpen: true, onClose: close, directoryTypeHint: _types.DirectoryTab.PATIENTS, orgKeyContext: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 525}} )
      )
      ,  _optionalChain([action, 'optionalAccess', _13 => _13.kind]) === 'tag' && (
        _react2.default.createElement(TagDialog, {
          count: count,
          isOne: isOne,
          tags: tags,
          isBusy: isBusy,
          onClose: close,
          onAdd: addTag,
          onRemove: tag => untag(tag, target), __self: this, __source: {fileName: _jsxFileName, lineNumber: 528}}
        )
      )
      ,  _optionalChain([action, 'optionalAccess', _14 => _14.kind]) === 'broadcast' && (
        _react2.default.createElement(BroadcastDialog, {
          orgKey: orgKey,
          count: count,
          isOne: isOne,
          selection: target,
          isBusy: isBusy,
          onClose: close,
          onAdd: addToBroadcast,
          onCreate: createBroadcast, __self: this, __source: {fileName: _jsxFileName, lineNumber: 539}}
        )
      )
      ,  _optionalChain([action, 'optionalAccess', _15 => _15.kind]) === 'archive' && (
        _react2.default.createElement(ArchiveDialog, { count: count, isBusy: isBusy, onClose: close, onConfirm: () => startArchive(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 551}} )
      )
    )
  )
}

exports. default = PatientActions
